"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getCountries;
var _metadata = _interopRequireDefault(require("./metadata.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getCountries(metadata) {
  return new _metadata["default"](metadata).getCountries();
}
//# sourceMappingURL=getCountries.js.map